import type { ReactNode } from 'react'

/**
 * Los tres estados que no son la pantalla: cargando, se rompió, no hay nada.
 *
 * Están juntos y no adentro de cada pantalla porque acá la red es mala de
 * verdad —un teléfono en un salón lleno— y esos tres estados se ven bastante
 * más seguido que en una app de escritorio. Que se vean siempre iguales es lo
 * que hace que el jugador aprenda a distinguirlos de un vistazo: uno pasa solo,
 * otro se reintenta y el tercero no se arregla esperando.
 */

export function Cargando({ que }: { que: string }) {
  return (
    <p className="cargando" role="status">
      <span className="cargando-punto" aria-hidden="true" />
      {que}
    </p>
  )
}

export function Problema({ mensaje, alReintentar }: { mensaje: string; alReintentar?: () => void }) {
  return (
    <div className="aviso error" role="alert">
      <strong>No se pudo cargar</strong>
      <p>{mensaje}</p>
      {alReintentar && (
        <button className="boton secundario" onClick={alReintentar}>
          Reintentar
        </button>
      )}
    </div>
  )
}

export function Vacio({ titulo, children }: { titulo: string; children?: ReactNode }) {
  return (
    <div className="vacio">
      <strong>{titulo}</strong>
      {children}
    </div>
  )
}
